import * as turf from "@turf/turf"

const load_data_into_source = (map_ref, source_id, data) => {
  const source = map_ref.getSource(source_id)
  if (source) {
    source.setData(data)
  } else {
    console.log(`Map source ${source_id} not found.`)
  }
}

const calculate_initial_boundaries = (analysis_units) => {
  // Step 1: Filter features with valid cup_id
  const validFeatures = analysis_units.features.filter(
    (feature) =>
      feature.properties.cup_id !== undefined &&
      feature.properties.cup_id !== null &&
      feature.properties.cup_id !== -1,
  )

  // Step 2: Flatten MultiPolygons into Polygons
  const flattenedFeatures = validFeatures.flatMap((feature) => {
    if (feature.geometry.type === "MultiPolygon") {
      return feature.geometry.coordinates.map((polygonCoords) => ({
        type: "Feature",
        geometry: {
          type: "Polygon",
          coordinates: polygonCoords,
        },
        properties: { ...feature.properties },
      }))
    } else {
      return [feature]
    }
  })

  // Step 3: Create a clean FeatureCollection
  const featureCollection = turf.featureCollection(flattenedFeatures)

  // Step 4: Dissolve by cup_id (now all features are Polygon)
  const dissolved = turf.dissolve(featureCollection, {
    propertyName: "cup_id",
  })

  // Step 5: Assign feature.id = cup_id (parsed as int)
  dissolved.features.forEach((feature) => {
    feature.id = parseInt(feature.properties.cup_id)
  })

  return dissolved
}

const import_data = ({
  dispatch_map_data,
  data,
  map_ref,
  set_change_requests,
}) => {
  const {
    facilities,
    analysis_units,
    cups,
    provinces,
    district_municipalities,
    health_sub_districts,
    wards,
    ChangeRequests,
  } = data

  set_change_requests(ChangeRequests)
  ;[
    ["source_provinces", provinces],
    ["source_district_municipalities", district_municipalities],
    ["source_sub_districts", health_sub_districts],
    ["source_wards", wards],
  ].forEach(([source_id, data]) => {
    load_data_into_source(map_ref, source_id, data)
  })

  let cup_boundaries = calculate_initial_boundaries(analysis_units)

  dispatch_map_data({
    type: "SET_DATA",
    payload: {
      fac_geo_json: facilities,
      au_geo_json: analysis_units,
      cup_geo_json: cups,
      cup_boundary_geo_json: cup_boundaries,
      province_geo_json: provinces,
      district_geo_json: district_municipalities,
      sub_district_geo_json: health_sub_districts,
      ward_geo_json: wards,
    },
  })

  const bounds = turf.bbox(analysis_units)
  map_ref.fitBounds(bounds)
}

export default import_data
